var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveDocumentsTermLoan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 14.1693V15.8359C13.3337 16.7564 12.5875 17.5026 11.667 17.5026H5.83366C4.91318 17.5026 4.16699 16.7564 4.16699 15.8359V7.5026C4.16699 6.58213 4.91318 5.83594 5.83366 5.83594H7.50033",
    stroke: "#4B465C",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 14.1693V15.8359C13.3337 16.7564 12.5875 17.5026 11.667 17.5026H5.83366C4.91318 17.5026 4.16699 16.7564 4.16699 15.8359V7.5026C4.16699 6.58213 4.91318 5.83594 5.83366 5.83594H7.50033",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5V5.83333C12.5 6.29357 12.8731 6.66667 13.3333 6.66667H16.6667",
    stroke: "#4B465C",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5V5.83333C12.5 6.29357 12.8731 6.66667 13.3333 6.66667H16.6667",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14.1667H9.16667C8.24619 14.1667 7.5 13.4205 7.5 12.5V4.16667C7.5 3.24619 8.24619 2.5 9.16667 2.5H12.5L16.6667 6.66667V12.5C16.6667 13.4205 15.9205 14.1667 15 14.1667Z",
    stroke: "#4B465C",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14.1667H9.16667C8.24619 14.1667 7.5 13.4205 7.5 12.5V4.16667C7.5 3.24619 8.24619 2.5 9.16667 2.5H12.5L16.6667 6.66667V12.5C16.6667 13.4205 15.9205 14.1667 15 14.1667Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveDocumentsTermLoan);
export default __webpack_public_path__ + "static/media/inactive-documents-term-loan.a0c6bfee0b8a8304bcdb96a2cc29f8f1.svg";
export { ForwardRef as ReactComponent };